import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { BaseDataReducerV2InitialState, basedDataReducerV2 } from 'redux/base-reducer-v2';

import { IEecsWhiteList, IEecsWhiteListModal } from '../types';

export interface InitialState extends BaseDataReducerV2InitialState<IEecsWhiteList> {
  currentModal: IEecsWhiteListModal | null;
  selectedWhiteList: IEecsWhiteList | null;
}

const { initialState, AC, reducer } = basedDataReducerV2<IEecsWhiteList, InitialState>('eecs-white-list');

const eecsWhiteListInitialState: InitialState = {
  ...initialState,
  currentModal: null,
  selectedWhiteList: null,
};

export const eecsWhiteList = createSlice({
  name: 'eecsWhiteList',
  initialState: eecsWhiteListInitialState,
  reducers: {
    setSelectedWhiteList: (state, action: PayloadAction<IEecsWhiteList | null>) => {
      state.selectedWhiteList = action.payload;
    },
    setWhiteListModal: (state, action: PayloadAction<IEecsWhiteListModal | null>) => {
      state.currentModal = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addDefaultCase((state, action) => {
      return reducer(state as InitialState, action);
    });
  },
});
export const EecsWhiteListAC = AC;

export const { setWhiteListModal, setSelectedWhiteList } = eecsWhiteList.actions;
